<template>
  <div class="ImmuneTestList">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="queryData">
          <el-input
            style="width: 150px"
            placeholder="请输入名称"
            v-model.trim="queryData.keyWord"
            @keyup.enter.native="getDataList(true)"
            clearable
          >
          </el-input>
          <el-select
            v-model="queryData.status"
            class="inputS"
            placeholder="状态"
            @change="getDataList(true)"
            clearable
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="success" @click="getDataList">查询</el-button>
          <el-button class="inputR" type="primary" @click="addOrEditPopup(0)"
            >新增</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loadingFlag"
        element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading"
        stripe
      >
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="180">
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="350">
        </el-table-column>
        <el-table-column prop="sort" label="排序" min-width="80">
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
            <el-tag type="danger" v-if="scope.row.status == 2">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180">
          <template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="addOrEditPopup(scope.row)"
              style="marin-right: 20px"
              >编辑</el-button
            >
            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="getDataListSizeChange"
        @current-change="getDataListCurrentChange"
        :current-page="queryData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="dataForm.id ? '修改' : '新增'"
      :visible.sync="centerDialogVisible"
      width="800px"
      center
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="80px"
        :rules="dataFormRules"
      >
        <el-form-item prop="title" label="名称">
          <el-input
            v-model.trim="dataForm.title"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="description" label="描述">
          <el-input
            resize="none"
            rows="3"
            type="textarea"
            v-model.trim="dataForm.description"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品图片">
          <el-upload
            class="avatar-uploader"
            :action="`${$store.state.uploadImgUrl}?access_token=${$store.state.access_token}`"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :on-error="this.$uploadError"
            :before-upload="this.$beforeUploadImage"
            accept="image/*"
          >
            <img
              v-if="dataForm.image"
              style="width: auto; max-width: 100%; height: 200px"
              :src="dataForm.image"
              class="avatar"
            />
            <i
              style="
                width: 200px;
                height: 200px;
                font-size: 30px;
                line-height: 200px;
              "
              v-else
              class="el-icon-plus avatar-uploader-image"
            ></i>
          </el-upload>
          <div>推荐尺寸：1920*380 提高清晰度可以等比加大</div>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            :min="1"
            placeholder="排序"
            v-model.trim="dataForm.sort"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDataForm" :loading="loadingFlag"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      queryData: {
        current: 1,
        size: 10,
        keyWord: "",
        status: "",
        type: 1,
      },
      dataForm: {},
      total: 0,
      centerDialogVisible: false,
      loadingFlag: false,
      dataFormRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        sort: [{ required: true, message: "请选择排序", trigger: "blur" }],
      },
      statusList: [
        {
          label: "启用",
          value: 1,
        },
        {
          label: "禁用",
          value: 2,
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getDataList();
  },
  methods: {
    // 新增
    addOrEditPopup(row) {
      this.centerDialogVisible = true;
      if (row) {
        this.dataForm = JSON.parse(JSON.stringify(row));
      } else {
        this.dataForm = {
          status: 1,
          sort: 1,
        };
      }
    },
    // changeTopping(e, id) {
    //   if (e) {
    //     this.$http.post(`/news/setProductTopById?id=${id}`).then((res) => {
    //       if (res.data.code == 200) {
    //         this.getDataList();
    //       }
    //     });
    //   } else {
    //     this.$http
    //       .put(`/news/updateById`, {
    //         id,
    //         top: e,
    //       })
    //       .then((res) => {
    //         if (res.data.code == 200) {
    //           this.getDataList();
    //         }
    //       });
    //   }
    // },
    /**
     * 删除数据
     */
    baseDeleteById(id) {
      if (id) {
        this.$confirm("是否删除所选择的数据?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http
              .delete(`/inspection-items/baseDeleteById/${id}`)
              .then((res) => {
                if (res.data.code == 200) {
                  this.getDataList();
                  this.$VueMessage({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {
                  this.$VueMessage({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              });
          })
          .catch(() => {
            this.$VueMessage({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    /**
      提交
     */
    uploadSuccess(res) {
      this.$store.state.beforeUploadLoading.close();
      this.$set(this.dataForm, "image", res.data);
    },
    submitDataForm() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loadingFlag = true;
          let url = "/inspection-items/saveOrUpdate";
          let data = this.dataForm;
          this.$http.post(`${url}`, data).then((res) => {
            this.loadingFlag = false;
            if (res.data.code == 200) {
              this.$VueMessage({
                message: "操作成功",
                type: "success",
              });
              this.centerDialogVisible = false;
              this.getDataList();
              // this.$emit("refreshDataList");
            } else {
              this.$VueMessage({
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
    // 查询
    getDataList(flag) {
      let data = this.queryData;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        // .post(`/sys-banner/page`, this.$guolv(this.queryData))
        .get(`/inspection-items/getSelectPage`, {
          params: data,
        })
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              this.tableData = list;
              this.total = data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange(val) {
      this.queryData.size = val;
      this.getDataList(true);
    },
    getDataListCurrentChange(val) {
      this.queryData.current = val;
      this.getDataList();
    },
  },
};
</script>